import { useApiPost } from '@/api/main/query'
import { disputsAPI } from '../api/endpoints'
import { DisputListModel, DisputStatus, NewStatusDisputModel } from '../model/types'
import { useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/shared/hooks'

type ExtendedDisputModel = NewStatusDisputModel & {
  topupId?: string
}

export const useUpdateDisputStatus = (disputId: string) => {
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const { mutate: updateStatus } = useApiPost<DisputListModel, NewStatusDisputModel>(
    disputsAPI.updateStatus,
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries({ queryKey: ['disput', disputId] })
        queryClient.invalidateQueries({ queryKey: ['disputs'] })

        const extendedVars = variables as ExtendedDisputModel
        if (extendedVars.status === DisputStatus.Satisfied && extendedVars.topupId) {
          queryClient.invalidateQueries({ queryKey: ['topup', extendedVars.topupId] })
          queryClient.invalidateQueries({ queryKey: ['topups'] })
        }
      },

      onError: (error) => {
        addToast('Ошибка!', error.message, 'error')
      },
    }
  )

  const handleUpdateStatus = (data: ExtendedDisputModel) => {
    const { topupId, ...payload } = data
    updateStatus(payload as NewStatusDisputModel)
  }

  return { handleUpdateStatus }
}
